import * as Constants from './constants'

const initialState = {
  list: [],
  item: {},
  resultUser: [],
  resultNgDung: [],
  type: Constants.NGUOIDUNGKHO_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
  callback: function () { },
}

const reducer = function nguoiDungKhoReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.NGUOIDUNGKHO_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NGUOIDUNGKHO_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.NGUOIDUNGKHO_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.NGUOIDUNGKHO_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NGUOIDUNGKHO_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        resultUser: action.data.resultUser || [],
        resultNgDung: action.data.resultNgDung || [],
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.NGUOIDUNGKHO_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.NGUOIDUNGKHO_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.NGUOIDUNGKHO_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }]
      }

    case Constants.NGUOIDUNGKHO_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/NguoiDungKho/reducer.js